var UserDataValidation = function() {
    return {
        hideUsernameErrorPrompts: function() {
            $('#username_container').removeClass('error');
            $('#username_prompt').hide();
            $('#username_hint').hide();
        },
        showUsernameErrorPrompts: function(reason) {
            $('#username_container').addClass('error');
            if (reason == 'user_exists' || reason == 'server') {
                $('#username_prompt').show();
            } else if (reason == 'invalid') {
                $('#username_hint').show();
            }
        },
        hideEmailErrorPrompt: function() {
            $('#email_container').removeClass('error');
            $('#email_prompt').hide();
        },
        showEmailErrorPrompt: function() {
            $('#email_container').addClass('error');
            $('#email_prompt').show();
        },
        hidePasswordPrompts: function() {
            $('.ii__pwd_container').removeClass('success');
            $('.ii__pwd_container').removeClass('error');
            $('#pwd_prompt').hide();
            $('#pwd_hint').hide();
            $('#pwd_success').hide();
        },
        showPasswordErrorPrompt: function(reason) {
            $('.ii__pwd_container').addClass('error');
            if (reason == 'mismatch') {
                $('#pwd_prompt').show();
            } else if (reason == 'invalid') {
                $('#pwd_hint').show();
            } else if (reason == 'server') {
                $('#pwd_fail').show();
            }
        },
        showPasswordSuccess: function() {
            $('.ii__pwd_container').addClass('success');
            $('#pwd_success').show();
        },
        checkPwd: function(pwd, pwdConfirm) {
            if (pwd.length < 3) {
                UserDataValidation.showPasswordErrorPrompt('invalid');
                return false;
            }
            if (pwdConfirm && pwd != $('#password_again').val()) {
                UserDataValidation.showPasswordErrorPrompt('mismatch');
                return false;
            }
            return true;
        },
        checkEmail: function(email) {
            return email == '' || /^[A-Z0-9._-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
        },
        hideLoginPrompt: function() {
            $('.ii__login_data_container').removeClass('error');
            $('#login_prompt').hide();
        },
        showLoginPrompt: function() {
            $('.ii__login_data_container').addClass('error');
            $('#login_prompt').show();
        },
        checkUsername: function(username, cb) {
            cb = Util.defaultFor(cb, false);
            if (username == '') {
                UserDataValidation.showUsernameErrorPrompts('Κενό όνομα χρήστη');
                return;
            }
            Ajax.checkUsername(username, function(res) {
                if (res.success != 'ok') {
                    UserDataValidation.showUsernameErrorPrompts(res.reason);
                    if (cb) {
                        cb(true);
                    }
                    return;
                } else {
                    if (cb) {
                        cb(false);
                    }
                    return;
                }
            });
        },
        init: function(allow_empty_username) {
            $('#username').blur(function() {
                UserDataValidation.hideUsernameErrorPrompts();
                var username = $(this).val();
                if (username == '' && allow_empty_username) {
                    return;
                }
                UserDataValidation.checkUsername(username);
            });
            $('#email').on('input blur', function() {
                UserDataValidation.hideEmailErrorPrompt();
                var email = $(this).val();
                if (!UserDataValidation.checkEmail(email)) {
                    UserDataValidation.showEmailErrorPrompt();
                }
            });
        }
    };
}();
